export default __webpack_public_path__ + "static/media/strawberries.a137f196.jpg";